// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g6on270 {
  margin-left: auto;
  margin-right: auto;
  padding: var(--_18w76bwe) var(--_18w76bwl);
  max-width: 468px;
}
.g6on271 {
  padding: var(--_18w76bw9) var(--_18w76bw9) var(--_18w76bwn) var(--_18w76bw9);
}
.g6on272 {
  padding: 0 5px;
}
@media screen and (min-width: 768px) {
  .g6on270 {
    margin-left: unset;
    margin-right: unset;
    width: 40vw;
    padding: var(--_18w76bwe) var(--_18w76bwt) var(--_18w76bwl);
    border-right: 1px solid var(--_18w76bw27);
  }
  .g6on271 {
    padding: var(--_18w76bwi) var(--_18w76bwn) var(--_18w76bwn) var(--_18w76bwn);
    max-width: 440px;
    align-self: stretch;
    justify-content: space-between;
  }
}
@media screen and (min-width: 1024px) {
  .g6on270 {
    width: 32vw;
    max-width: 400px;
    padding: var(--_18w76bwe) var(--_18w76bwt) var(--_18w76bwl);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,2DAA2D;IAC3D,yCAAyC;EAC3C;EACA;IACE,4EAA4E;IAC5E,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,2DAA2D;EAC7D;AACF","sourcesContent":[".g6on270 {\n  margin-left: auto;\n  margin-right: auto;\n  padding: var(--_18w76bwe) var(--_18w76bwl);\n  max-width: 468px;\n}\n.g6on271 {\n  padding: var(--_18w76bw9) var(--_18w76bw9) var(--_18w76bwn) var(--_18w76bw9);\n}\n.g6on272 {\n  padding: 0 5px;\n}\n@media screen and (min-width: 768px) {\n  .g6on270 {\n    margin-left: unset;\n    margin-right: unset;\n    width: 40vw;\n    padding: var(--_18w76bwe) var(--_18w76bwt) var(--_18w76bwl);\n    border-right: 1px solid var(--_18w76bw27);\n  }\n  .g6on271 {\n    padding: var(--_18w76bwi) var(--_18w76bwn) var(--_18w76bwn) var(--_18w76bwn);\n    max-width: 440px;\n    align-self: stretch;\n    justify-content: space-between;\n  }\n}\n@media screen and (min-width: 1024px) {\n  .g6on270 {\n    width: 32vw;\n    max-width: 400px;\n    padding: var(--_18w76bwe) var(--_18w76bwt) var(--_18w76bwl);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
